var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState, useEffect, useCallback } from 'react';
import { ticketsService } from 'src/Utils/ticketsService';
export var useTicketsWithFilters = function (initialFilters) {
    if (initialFilters === void 0) { initialFilters = {}; }
    var _a = useState([]), tickets = _a[0], setTickets = _a[1];
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    var _d = useState(0), totalPages = _d[0], setTotalPages = _d[1];
    var _e = useState(0), currentPage = _e[0], setCurrentPage = _e[1];
    var _f = useState(initialFilters), filters = _f[0], setFilters = _f[1];
    var fetchTickets = useCallback(function (page, filterParams) { return __awaiter(void 0, void 0, void 0, function () {
        var response, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setLoading(true);
                    setError(null);
                    return [4 /*yield*/, ticketsService.getTickets(__assign({ page: page + 1 }, filterParams))];
                case 1:
                    response = _a.sent();
                    setTickets(response.tickets || []);
                    if (response.total_pages)
                        setTotalPages(response.total_pages);
                    return [3 /*break*/, 4];
                case 2:
                    err_1 = _a.sent();
                    setError('Error al cargar los tickets');
                    console.error('Error fetching tickets:', err_1);
                    return [3 /*break*/, 4];
                case 3:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, []);
    useEffect(function () {
        fetchTickets(currentPage, filters);
    }, [currentPage, filters, fetchTickets]);
    var handleSetPage = function (page) {
        setCurrentPage(page);
    };
    var handleSetFilters = useCallback(function (newFilters) {
        setFilters(newFilters);
        setCurrentPage(0); // Reset to first page when filters change
    }, []);
    var refetch = useCallback(function () {
        fetchTickets(currentPage, filters);
    }, [fetchTickets, currentPage, filters]);
    return {
        tickets: tickets,
        loading: loading,
        error: error,
        totalPages: totalPages,
        currentPage: currentPage,
        setPage: handleSetPage,
        setFilters: handleSetFilters,
        refetch: refetch,
    };
};
